module.exports = require("events");;